import { groq } from "next-sanity";

export const newsTypesQuery = groq`*[_type == "newsType"] {
  title,
  slug.current,
}`;
